export default __webpack_public_path__ + "static/media/backgroundShadow.84ff2294.png";